module.exports = __webpack_public_path__ + "static/Highlight2-96029d3c13ebd447f5c68a1a3cd14484.png";